import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const MoreIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <path
        d="M7.25 7.66667V8.33333C7.25 8.56345 7.43655 8.75 7.66667 8.75H8.33333C8.56345 8.75 8.75 8.56345 8.75 8.33333V7.66667C8.75 7.43655 8.56345 7.25 8.33333 7.25H7.66667C7.43655 7.25 7.25 7.43655 7.25 7.66667Z"
        fill={color}
      />
      <path
        d="M12 7.66667V8.33333C12 8.56345 12.1865 8.75 12.4167 8.75H13.0833C13.3135 8.75 13.5 8.56345 13.5 8.33333V7.66667C13.5 7.43655 13.3135 7.25 13.0833 7.25H12.4167C12.1865 7.25 12 7.43655 12 7.66667Z"
        fill={color}
      />
      <path
        d="M2.5 7.66667V8.33333C2.5 8.56345 2.68655 8.75 2.91667 8.75H3.58333C3.81345 8.75 4 8.56345 4 8.33333V7.66667C4 7.43655 3.81345 7.25 3.58333 7.25H2.91667C2.68655 7.25 2.5 7.43655 2.5 7.66667Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

MoreIcon.displayName = 'MoreIcon';
